import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { CopyPurchasingOrgContainer } from './styled' 
import { getBPPurchasingOrgs, getBPPurchasingView } from 'ducks/vendorMaintenance'
import { getCurrencies, getPaymentTerms, getPurchasingOrgs, getIncoterms } from 'ducks/options'
import PurchasingOrgCell from './PurchasingOrgCell'

const CopyPurchasingOrgForm = (props) => {
  const { valueForm, change, currencies, incoterms, paymentTerms, purchasingOrgs, vendorPurchasingOrgs } = props

  useEffect(() => {
    if (!currencies.data.length && !currencies.loading) {
      props.getCurrencies()
    }

    if (!incoterms.data.length && !incoterms.loading) {
      props.getIncoterms()
    }

    if (!paymentTerms.data.length && !paymentTerms.loading) {
      props.getPaymentTerms()
    }

    if (!purchasingOrgs.data.length && !purchasingOrgs.loading) {
      props.getPurchasingOrgs()
    }
  }, [])

  useEffect(() => {
    if (valueForm.vendorCode) {
      props.getBPPurchasingOrgs(valueForm.vendorCode)
    }
  }, [valueForm.vendorCode])

  const onLoadPurchasingViewSuccess = (data) => {
    const getBoolValue = (value, defaultValue) => {
      return (value !== undefined && value !== null && value !== '') ? value : defaultValue
    }

    change('usePurchasingView', getBoolValue(data.usePurchasingView, false))
    change('orderCurrency', data.orderCurrency || '')
    change('paymentTerms', data.paymentTerms || '')
    change('salePerson', data.salePerson || '')
    change('salePersonTelephone', data.salePersonTelephone || '')
    change('incoterm', data.incoterm || '')
    change('incotermsLocation', data.incotermsLocation || '')
    change('grBasedInvoiceVerification', getBoolValue(data.grBasedInvoiceVerification, false))
    change('purchasingViewLoaded', true)
  }

  const onChangePurchasingOrg = (value) => {
    if (valueForm.purchasingOrg !== value) {
      change('usePurchasingView', false)
      change('orderCurrency', '')
      change('paymentTerms', '')
      change('salePerson', '')
      change('salePersonTelephone', '')
      change('incoterm', '')
      change('incotermsLocation', '')
      change('grBasedInvoiceVerification', false)
      change('purchasingViewLoaded', false)
      change('copyPurchasingOrg', [])

      if (value !== null && value !== undefined && value !== '') {
        props.getBPPurchasingView(valueForm.vendorCode, value, onLoadPurchasingViewSuccess)
      }
    }
  }

  const GetTextFromOption = (options, value) => {
    if (value === null || value === undefined || value === '') return '-'
    var x = options.data.find(x => x.value === value)
    return x ? x.text : value
  }

  const LabelAndValue = (label, value) => {
    return (
      <tr>
        <td style={{ verticalAlign: 'top', fontWeight: 'bold' }}>{label}</td>
        <td style={{ verticalAlign: 'top' }}>{value}</td>
      </tr>
    )
  }

  const purchasingOrgIsActiveInSAP = (value) => {
    return vendorPurchasingOrgs.data.find(x => x.value === value) !== undefined
  }

  const purchasingOrgIsSelected = (value) => {
    return (valueForm.copyPurchasingOrg || []).includes(value) || (value === valueForm.purchasingOrg)
  }

  const renderPurchasingOrgDestination = () => {
    return (
      <React.Fragment>
        {
          valueForm.status === 4 ?
          valueForm.copyPurchasingOrg.map(x => {
            var purchOrgOption = purchasingOrgs.data.find(p => p.value === x)
            return (
              <div>
                {purchOrgOption ? purchOrgOption.text : x}
              </div>
            )
          }) :
          purchasingOrgs.data.map(x => {
            return (
              <PurchasingOrgCell 
                title={x.text} 
                value={x.value} 
                disable={purchasingOrgIsActiveInSAP(x.value)} 
                selected={purchasingOrgIsSelected(x.value) || purchasingOrgIsActiveInSAP(x.value)}
                onClick={(value) =>{
                  if (!purchasingOrgIsActiveInSAP(x.value) && valueForm.status !== 4) {
                    var data = [...(valueForm.copyPurchasingOrg || [])]
                    if (purchasingOrgIsSelected(x.value)) {
                      data.splice(data.indexOf(x.value), 1)
                    } else {
                      data.push(x.value)
                    }
                    change('copyPurchasingOrg', data)
                  }
                }}
              />
            )
          })
        }
      </React.Fragment>
    )
  }

  return (
    <CopyPurchasingOrgContainer>
      <div className='purchasingOrgSection'>
        <div className='sourceSection'>
          <div className='subTitle'>Source Purchasing Org</div>
          {
            valueForm.status === 4 ? null :
            <Field 
              name='purchasingOrg' 
              label='Purchasing Org '  
              options={vendorPurchasingOrgs.data}
              loading={vendorPurchasingOrgs.loading}
              editable={(valueForm.status === undefined || valueForm.status === 0)}
              type={type.select}
              require
              specialOnChange={onChangePurchasingOrg}
              containerStyle={{ flex: 'unset' }}
              component={FieldInput} />
          }
          <table>
            {
              valueForm.status === 4 ?
              LabelAndValue('Purchasing Org', GetTextFromOption(vendorPurchasingOrgs, valueForm.purchasingOrg)) : null
            }
            {LabelAndValue('Order Currency', GetTextFromOption(currencies, valueForm.orderCurrency))}
            {LabelAndValue('Payment Terms', GetTextFromOption(paymentTerms, valueForm.paymentTerms))}
            {LabelAndValue('Sale Person', valueForm.salePerson || '-')}
            {LabelAndValue('Sale Person Telephone', valueForm.salePersonTelephone || '-')}
            {LabelAndValue('Incoterm', GetTextFromOption(incoterms, valueForm.incoterm))}
            {LabelAndValue('Incoterms Location', valueForm.incotermsLocation || '-')}
            {LabelAndValue('GR-Based Invoice Verification', valueForm.grBasedInvoiceVerification ? 'Yes' : 'No')}
          </table>
        </div>
        <div className='destinationSection'>
          <div className='subTitle'>
            Destination Purchasing Org
            <Field name='copyPurchasingOrg' label='' require type={type.labelOnly} component={FieldInput} />
          </div>
          {
            valueForm.purchasingOrg ? renderPurchasingOrgDestination() : null
          }
        </div>
      </div>
    </CopyPurchasingOrgContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    currencies: state.options.currencies,
    incoterms: state.options.incoterms,
    paymentTerms: state.options.paymentTerms,
    purchasingOrgs: state.options.purchasingOrgs,
    vendorPurchasingOrgs: state.vendorMaintenance.vendorPurchasingOrgs
  })
}
  

const mapDispatchToProps = {
  getCurrencies,
  getIncoterms,
  getPaymentTerms,
  getPurchasingOrgs,
  getBPPurchasingOrgs,
  getBPPurchasingView,
}

export default connect(mapStateToProps, mapDispatchToProps)(CopyPurchasingOrgForm)